<template lang="pug">
.t-content
  #downline-bonus.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-dialog-centered.modal-dialog-scrollable
      .modal-content.rfpop
        .modal-body
          h3
            | Claim Your Downline Member
            br
            | Bonus from Live Chat
          br
          button.btn-submit(type='button' @click.prevent="modalAction")
            i.fa-solid.fa-comment-dots
            |  Live Chat
  section.info-sec
    .max-container(v-show="showDefault")
      .refer-wrapper
        .rftop.pointer(v-if="isLoggedIn")
          .ttitle
            img(src='/images/refer/downline.png')
            <p>Downline Member Bonus</p>
          .amount
            a(href="javascript:void(0)" @click="showDetails(0)")
              span MYR {{ $numeral(referCount).format("0,0.00") }}
              i.fa.fa-chevron-right
            button.btn-submit(data-dismiss='modal' @click="$helpers.openModal('#downline-bonus')") Claim
        .rftop.pointer(v-if="isLoggedIn")
          .ttitle
            img(src='/images/refer/cashback.png')
            <p>10% Cashback Bonus</p>
          .amount
            a(href="javascript:void(0)" @click="showDetails(1)")
              span MYR {{ $numeral(referRebate).format("0,0.00") }}
              i.fa.fa-chevron-right
        .rfban
          img(src='/images/refer/referral.jpg')
        .rfwrap(v-if="isLoggedIn")
          .rffield
            .ttitle Share your link
            .field
              input(type='text' :value='referralLink' readonly)
              button.btn-submit(@click="copyClipboard") Copy 
                i.fa.fa-copy
          .contactlist
            a(:href="whatsappLink")
              img(src='/images/follow/whatsapp.png')
            a(:href="tgLink")
              img(src='/images/follow/telegram.png')
            a(:href="fbLink")
              img(src='/images/follow/facebook.png')
            //- a(href='#')
              img(src='/images/contact/c-share.png')
        .rfwrap
          h5 You get
          .cilist
            i.fa.fa-check-circle
            span 1 Referral = RM1
          .cilist
            i.fa.fa-check-circle
            span Unlimited RM20 Cashback Bonus
        .rfwrap
          h5 Your Friends Get
          .cilist
            i.fa.fa-check-circle
            span Free Credit RM10
          //- .cilist
            i.fa.fa-check-circle
            span Bonus up to MYR 100*
        
        .rfbtm
          router-link(to="/promotions") Terms and Conditions
  .max-container.v2(v-show="!showDefault")
    .infobox.epw-nwrap.inbox-wrap
      .text-start.px-2.mb-2.pointer(@click="closeDetails")
        i.fa-solid.fa-circle-chevron-left
        | &nbsp;{{$t('ui.back')}}
      .abtn-group
        a.abtn.epw-ntabs(href='javascript:void(0)' :class="{'active': selectedTab === 0}" @click="changeTab(0)") Downline
        a.abtn.epw-ntabs(href='javascript:void(0)' :class="{'active': selectedTab === 1}" @click="changeTab(1)") Cashback
      .tab-content
        .inboxcons.epw-ncons(:class="{'active': selectedTab === 0}")
          .table-responsive
            table.table-history
              thead
                tr
                  th No
                  th ID
                  th Bonus
                  th Register Date &amp; Time
              tbody
                template(v-if="referCountDetail.length>0")
                  tr(v-for="(detail, index) in referCountDetail")
                    td {{index+1}}
                    td {{detail.account_id}}
                    td MYR {{ $numeral(detail.amount).format("0,0.00") }}
                    td {{ $moment(detail.verified_date).format("YYYY-MM-DD HH:mm:ss") }}
                template(v-else)
                  tr
                    td(colspan="4") No Record Found
        .inboxcons.epw-ncons(:class="{'active': selectedTab === 1}")
          .table-responsive
            table.table-history
              thead
                tr
                  th No
                  th ID
                  th Bonus
                  th Cashback Credited Date &amp; Time
              tbody
                template(v-if="referRebateDetail.length>0")
                  tr(v-for="(detail, index) in referRebateDetail")
                    td {{index+1}}
                    td {{detail.member_id}}
                    td MYR {{ $numeral(detail.rebate_amount).format("0,0.00") }}
                    td {{ $moment(detail.created_date).format("YYYY-MM-DD HH:mm:ss") }}
                template(v-else)
                  tr
                    td(colspan="4") No Record Found
    //- .tabbox
      .panelbox
        .panel-holder
          .resbox
            .resbox-con
              .resbox-cusbox.referrall.aaa
                .resbox-tabs
                  .member-setting
                    .member-setting-title.custom-display
                      .member-setting-icon
                        i.fas.fa-users
                      .member-setting-text.flex-grow-1.text-left(v-if="showDownline") 
                        span.pointer(@click="hideDownline") {{$t('ui.referral')}}
                        span > 
                        span {{downlineId}}
                        //- .btn-sub.d-inline.pointer(@click="copyClipboard") {{getReferralcode}} 
                          i.fas.fa-copy
                      .member-setting-text.flex-grow-1.text-left(v-else) {{$t('ui.referral')}}
                        //- .btn-sub.d-inline.pointer(@click="copyClipboard") {{getReferralcode}} 
                          i.fas.fa-copy
                      .share-button(@click="closeDetails")
                        .btn-sub.d-inline.pointer.text-uppercase {{$t('ui.back')}} 
                      //- .share-button(@click="openModal('#modal-share')")
                        .btn-sub.d-inline.pointer {{$t('ui.share')}} 
                          i.fas.fa-share-alt
                      //- .referral-info(@click="openModal('#modal-referral-tnc')")
                        i.fa-solid.fa-circle-info
                    .member-setting-title.d-md-none
                      .member-setting-icon
                        i.fas.fa-users
                      .member-setting-text.flex-grow-1.text-left(v-if="showDownline") 
                        span.pointer(@click="hideDownline") {{$t('ui.referral')}}
                        span > 
                        span {{downlineId}}
                        //- .btn-sub.d-inline.pointer(@click="copyClipboard") {{getReferralcode}} 
                          i.fas.fa-copy
                      .member-setting-text.flex-grow-1.text-left(v-else) {{$t('ui.referral')}}
                        //- .btn-sub.d-inline.pointer(@click="copyClipboard") {{getReferralcode}} 
                          i.fas.fa-copy
                      .share-button(@click="closeDetails")
                        .btn-sub.d-inline.pointer.text-uppercase {{$t('ui.back')}} 
                      //- .share-button(@click="openModal('#modal-share')")
                        .btn-sub.d-inline.pointer {{$t('ui.share')}} 
                          i.fas.fa-share-alt
                      //- .referral-info(@click="openModal('#modal-referral')")
                        i.fas.fa-circle-info
                    .member-setting-title.d-md-none.d-block
                      .d-inline {{$t('ui.referral_link')}}
                      //- .btn-sub.d-inline.pointer(@click="copyClipboard") {{getReferralcode}} 
                        i.fas.fa-copy
                    ul.nav.nav-pills.nav-member
                      //- li.nav-item(@click="changeTab(0)")
                        .nav-link.active(data-bs-toggle='pill' data-bs-target='#referral-bonus') {{$t('ui.worldcup_2022')}}
                      //- li.nav-item(@click="changeTab(1)")
                        .nav-link(:class="{'active' : selectedTab == 1}"  data-bs-toggle='pill' data-bs-target='#downline-turnover') {{$t('ui.turnover_downline')}}
                      //- li.nav-item(@click="changeTab(2)")
                        .nav-link(:class="{'active' : selectedTab == 2}"  data-bs-toggle='pill' data-bs-target='#daily-game-rebate') {{$t('ui.daily_rebate')}}
                      li.nav-item(@click="changeTab(3)")
                        .nav-link(:class="{'active' : selectedTab == 3}"  data-bs-toggle='pill' data-bs-target='#referral-rebate') {{$t('ui.referral_rebate')}}
                    .tab-content.p-0.text-white
                      //- event(v-if="selectedTab === 0")
                      //- downLine(v-if="selectedTab === 1" @showDownlineTurnover="showDownlineTurnover" ref='downLine')
                      //- self(v-if="selectedTab === 2")
                      referralRebate(v-if="selectedTab === 3" @totalReferral="totalReferral")
</template>
<script>
// import promoModal from '@/components2/_promotionDetails.vue'
import event from '@/components2/referral/_event.vue'
// import self from '@/components2/referral/_self.vue'
import downLine from '@/components2/referral/_downLine.vue'
// import balance from '@/components2/_balance.vue'
import referralRebate from '@/components2/referral/_referralRebate.vue'
export default {
  // metaInfo:{
  //   title: 'EpicWin Referral Program | Earn Rewards by Inviting Friends',
  //   meta:[
  //     {vmid: "description",name: 'description', content: "Join our referral program and earn rewards by inviting your friends to play. Share the fun and get bonuses for each successful referral."}
  //   ],
  // },
  components:{
    event,
    // self,
    downLine,
    // balance,
    referralRebate,
    // promoModal
  },
  data(){
    return{
      selectedTab: 0,
      showDownline: false,
      rebateList:[],
      showDefault: true,
      totalRefAmt: "",
      referCount: "",
      referRebate: "",
      referCountDetail: [],
      referRebateDetail:[],
      feedback: {
        success: true,
        status: ""
      },
      metaData: []
    }
  },
  // metaInfo(){
  //   if(this.metaData.length> 0){
  //     return{
  //       title: this.metaData[0].meta_title || 'EpicWin Malaysia',
  //       meta:[
  //         { name: 'description',content: this.metaData[0].meta_desc },
  //         { name: "keywords", content: this.metaData[0].meta_keywords },
  //         { name: "author", content: this.metaData[0].meta_author },
  //         { name: "publisher", content: this.metaData[0].meta_publisher },

  //         { property: 'og:title', content: this.metaData[0].meta_title },
  //         { property: 'og:description', content: this.metaData[0].meta_desc },
          
  //       ],
  //       link: [
  //         { rel: 'canonical', href: this.metaData[0].meta_canonical }, // Sets the canonical URL
  //       ],
  //     }
  //   }else{
  //     return{
  //       title: 'EpicWin Malaysia',
  //       meta:[
  //         { name: 'description',content: 'EpicWin Malaysia' },
  //       ],
  //     }
  //   }
  // },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getReferralcode(){
      return this.$store.state.user.account.referral_code || ""
    },
    whatsappLink(){
      return `whatsapp://send?text=${window.location.protocol + "//" +window.location.hostname +"/register?ref="+ this.getReferralcode}`
    },
    fbLink(){
      return `https://www.facebook.com/sharer/sharer.php?u=${window.location.protocol + "//" +window.location.hostname +"/register?ref="+ this.getReferralcode}`
    },
    tgLink(){
      return `tg://msg_url?url=${window.location.protocol + "//" +window.location.hostname +"/register?ref="+ this.getReferralcode}`
    },
    referralLink(){
      return window.location.protocol + "//" +window.location.hostname +"/register?ref="+ this.getReferralcode
    },
  },
  watch:{
    sessionToken(newState, oldState){
      var vm = this
      if(newState === '' || newState === undefined){
        if(vm.showDefault === false){
          vm.showDefault = true
        }
        // vm.$router.push("/").catch(err => {});
      }else{
        this.getReferCount()
        this.getReferRebate()
      }
    }
  },
  created(){
    // $('link[rel="canonical"]').attr('href', 'https://www.epicwin.app/referral');
  },
  mounted(){
    window.scroll(0,0)
    // this.getRebateChart()
    this.getReferCount()
    this.getReferRebate()
    // this.getSeo()
  },
  methods:{
    getSeo(){			
      var temp = window.location.pathname.split("/")
      let page_name = temp[temp.length-1]
      let domain_name = window.location.hostname
			this.$store
				.dispatch("user/getSeo", {page_name, domain_name})
				.then(response => {
					this.loading = false;
					this.feedback.success = response.success
					if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
              this.metaData = response.data
						}
					} else {
						if((typeof response.status) != 'object'){
							this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
						}       
					}
				})
				.catch(response => {
					this.loading = false;
					var vm = this;
					if((typeof response.status) != 'object'){
						this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
					}
				});
		},
    modalAction(){
      this.$helpers.openChat()
      this.$helpers.closeModal('#downline-bonus')
    },
    totalReferral(e){
			this.totalRefAmt = e
		},
    showDetails(target){
      this.getReferCountDetail()
      this.getReferRebateDetail()
      this.selectedTab = target
      this.showDefault = false
    },
    closeDetails(){
      this.showDefault = true
    },
    openModal(target){
      $(target).modal('show')
    },
    copyClipboard(){
      if(!this.sessionToken) return;

      const g = document.createElement('div');
      g.id = "urlLink";
      g.innerHTML = window.location.protocol + "//" +window.location.hostname +"/register?ref="+ this.getReferralcode
      document.body.appendChild(g);
      var range = document.createRange();
      range.selectNode(document.getElementById("urlLink"));
      window.getSelection().removeAllRanges(); // clear current selection
      window.getSelection().addRange(range); // to select text
      document.execCommand("copy");
      window.getSelection().removeAllRanges();
      document.body.removeChild(g);
      this.$helpers.showDialog(this.$t("ui.success").toUpperCase(), this.$t("message.copy_clipboard"), "success", this)
    },
    changeTab(option){
      if(option === this.selectedTab){
        return;
      }else{
        this.selectedTab = option
      }
      this.showDownline = false
    },
    showDownlineTurnover(e){
      this.downlineId = e
      this.showDownline = true
    },
    hideDownline(){
      this.showDownline = false
      this.$refs.downLine.hideDownline()
    },
    getRebateChart(){
      if (this.sessionToken) {
        var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getRebateChart", { account_id, auth_token})
          .then(response => {
            if (response.success == true) {
              this.rebateList = response.data
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }else{
        return
      }
    },
    getReferCount(){
      if (this.sessionToken) {
        var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getReferCount", { account_id, auth_token})
          .then(response => {
            if (response.success == true) {
              if(response.data.length > 0){
                this.referCount = response.data[0].referee_count
              }
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }else{
        return
      }
    },
    getReferRebate(){
      if (this.sessionToken) {
        var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getReferRebate", { account_id, auth_token})
          .then(response => {
            if (response.success == true) {
              if(response.data.length > 0){
                this.referRebate = response.data[0].rebate_amount
              }
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }else{
        return
      }
    },
    getReferCountDetail(){
      if (this.sessionToken) {
        var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getReferCountDetail", { account_id, auth_token})
          .then(response => {
            if (response.success == true) {
              if(response.data.length > 0){
                this.referCountDetail = response.data
              }
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }else{
        return
      }
    },
    getReferRebateDetail(){
      if (this.sessionToken) {
        var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getReferRebateDetail", { account_id, auth_token})
          .then(response => {
            if (response.success == true) {
              if(response.data.length > 0){
                this.referRebateDetail = response.data
              }
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }else{
        return
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.nav-item{
  width: 100%;
}
.btn-sub{
  margin-left: 10px;
  padding: 5px;
  color: #5c4180;
}
.share-button{
  margin-right: 10px;
  font-size: 16px
}
.social{
  // text-decoration: none;
  // color: #ffffff;
  margin-bottom: 10px;
  &:hover{
    text-decoration: underline !important;
  }
  img{
    margin-right: 5px;
  }
}
.custom-display{
  display: none;
  @media(min-width: 768px){
    display: flex;
  }
}
.custom-p10{
  padding-left: 10px
}
.tab-content{
  @media(min-width: 992px){
    font-size: 16px;
  } 
}
.promotion-detail-wrapper{
  padding-top: 10px;
  font-size: 16px;
}
</style>